/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./route404.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./route404.component";
var styles_Route404Component = [i0.styles];
var RenderType_Route404Component = i1.ɵcrt({ encapsulation: 0, styles: styles_Route404Component, data: {} });
export { RenderType_Route404Component as RenderType_Route404Component };
export function View_Route404Component_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "h2", [["class", "text-center"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["404: Page not found :("]))], null, null); }
export function View_Route404Component_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-route404", [], null, null, null, View_Route404Component_0, RenderType_Route404Component)), i1.ɵdid(1, 114688, null, 0, i2.Route404Component, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var Route404ComponentNgFactory = i1.ɵccf("app-route404", i2.Route404Component, View_Route404Component_Host_0, {}, {}, []);
export { Route404ComponentNgFactory as Route404ComponentNgFactory };
